// src/api/mapTransformRequest.js
//
// MapLibre transformRequest for every map in this app.
//
// Moved here VERBATIM from MapView.jsx when the WellFinder review map needed
// it. It is the only place the imagery tile-auth contract is expressed on the
// client — X-Tile-Token as a header rather than a URL parameter, so tile URLs
// stay stable across token refreshes and MapLibre never re-tiles — and a second
// copy of that contract in a second map component is how the two drift.
//
// Not a rewrite. If this file and MapView's old inline version differ in any
// behaviour, this file is wrong.

import { getTokenForTileUrl } from "./tileTokens";
import { TILE_PATH } from "./tileUrl";

export function buildTransformRequest(getToken) {
  return (url) => {
    // Only touch URLs that are on our domain
    if (!(url.startsWith("/") || url.startsWith(window.location.origin))) {
      return { url };
    }

    const isApiOrInternal =
      url.includes("/api/") ||
      url.includes("/vtiles/") ||
      url.includes("/tile/") ||
      url.includes("/imagery/");

    const isImageryTile = url.includes(`${TILE_PATH}/`);

    // Imagery tile requests need BOTH the Keycloak bearer (for authz-api
    // session auth) AND the X-Tile-Token (for tile-level auth). The tile
    // token is held in tileTokens.js's cache and injected per-request via
    // header. URL stays stable across token refreshes — no setTiles
    // invalidation = no map flash.
    if (isImageryTile) {
      const bearer = getToken();
      const tileToken = getTokenForTileUrl(url);
      const headers = {};
      if (bearer) headers.Authorization = `Bearer ${bearer}`;
      if (tileToken) headers["X-Tile-Token"] = tileToken;
      return { url, headers };
    }

    // Other authz-api endpoints just need the Keycloak bearer
    if (isApiOrInternal) {
      const bearer = getToken();
      if (!bearer) return { url };
      return {
        url,
        headers: {
          Authorization: `Bearer ${bearer}`
        }
      };
    }

    return { url };
  };
}
